import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=42272a64&scoped=true&"
import script from "./AppointmentForm.vue?vue&type=script&lang=js&"
export * from "./AppointmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentForm.vue?vue&type=style&index=0&id=42272a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42272a64",
  null
  
)

export default component.exports